import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sameUser'
})
export class SameUserPipe implements PipeTransform {

  transform(value: string, user: string): any {
    return !(value === user || value === '');
  }

}



// WEBPACK FOOTER //
// ./src/app/same-user.pipe.ts